module.exports = __webpack_public_path__ + "static/media/blockhivelogo2.1acbc228.png";